import React, { useState, useEffect, useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Col, Container, Row, Tab } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import Table from 'react-bootstrap/Table';
import Laoding from '../shared/Laoding';
import ShowError from "../shared/ShowError";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as parameterHelper from '../shared/extraParameterHelper';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";

export default function WinAccounting(props) {
    const navigate = useNavigate();
    const targetRef1 = useRef(null);
    const [applyScroll, setApplyScroll] = useState(1);
    const [laodingProducts, setLaodingProducts] = useState(true);
    const [retryShowProductDetail, setRetryShowProductDetail] = useState(false);
    const [loadingProductDetatilErrorMessage, setLoadingProductDetatilErrorMessage] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [software, setSoftware] = useState("");
    const [packageCaption, setPackageCaption] = useState("");
    const [searchParams] = useSearchParams();
    const productEnName = "WinAccounting";
    const productType = {id:util.ProductTypes.WinHanaAccounting, title:"بسته های نرم افزاری حسابداری"};
    var softwareParam = searchParams.get("software");
    const [taxPercent, setTaxPercent] = useState(0);
    const [taxAmount, setTaxAmount] = useState(0);
    const [pricePerCleintForWinAccounting, setPricePerCleintForWinAccounting] = useState(0);
    const [pricePerVisitorForWinAccounting, setPricePerVisitorForWinAccounting] = useState(0);
    const [product, setProduct] = useState(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [maxClientNo, setMaxClientNo] = useState(0);
    const [maxVisitorNo, setMaxVisitorNo] = useState(0);
    const [modulePrice, setModulePrice] = useState(0);
    const [parameterPrice, setParameterPrice] = useState(0);
    const [discountMobile, setDiscountMobile] = useState("");
    const [discountToken, setDiscountToken] = useState("");
    const [discountValue, setDiscountValue] = useState(0);
    const [discountPercent, setDiscountPercent] = useState(0);
    const [checkDiscount, setCheckDiscount] = useState(false);

    useEffect(() => {
        if(applyScroll == 2){
            util.scrollToElement(targetRef1, "center");
            setApplyScroll(3);
            return;
        }
        else if(applyScroll == 3){
            return;
        }
        var packages = ["SimpleWinAccounting", "ServiceWinAccounting", "BusinesseWinAccounting", "VisitoryWinAccounting"
            , "BarFrooshiWinAccounting", "ResturantWinAccounting", "WorkersWinAccounting", "ProductWinAccounting"];
        var sn = softwareParam;
        if(!packages.includes(softwareParam)){
            sn = "SimpleWinAccounting"
        }
        setSoftware(sn);
        setPackageCaption(getPackageCaption(sn));
        loadProductDetail(sn);
    }, [applyScroll]);
    const loadProductDetail = (sn)=>{
        setLaodingProducts(true);
        setRetryShowProductDetail(false);
        var params = {param1:productEnName, param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/product-detail/get`;
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var user = util.getCurrentUser();
                response = response.data;
                var taxPrc = response.taxPercent;
                var p = response.product;
                setPricePerCleintForWinAccounting(response.pricePerCleintForWinAccounting);
                setPricePerVisitorForWinAccounting(response.pricePerVisitorForWinAccounting);
                setTaxPercent(taxPrc);
                var buy = util.getBuy();
                for(var i=0;i<p.modules.length;i++){
                    var m = {...p.modules[i]};
                    m["isChecked"] = m.isMandatory;
                    if(!m.isMandatory){
                        for(var j=0;j<p.productProposedOptions.length;j++){
                            var ppo = p.productProposedOptions[j];
                            if(ppo.code != sn)continue;
                            for(var k=0;k<ppo.moduleCodes.length;k++){
                                var m2 = ppo.moduleCodes[k];
                                if(m2.code == m.code){
                                    console.log("m2 is", m2);
                                    if(m2.isMandatory){
                                        m.isMandatory = true;
                                        m["isChecked"] = true;
                                    }
                                }
                            }
                        }
                    }
                    if((!m["isChecked"])&&(buy != null)){
                        if(buy.modules && buy.modules.includes(m.code)){
                            m["isChecked"] = true;
                        }
                    }
                    p.modules[i] = {...m};
                }
                setProduct(p);
                var cNo = 0;
                var vNo = 0;
                if(buy != null){
                    if(buy.parameters.maxClientNo) cNo = buy.parameters.maxClientNo;
                    if(buy.parameters.maxVisitorNo) vNo = buy.parameters.maxVisitorNo;
                }
                setMaxClientNo(cNo);
                setMaxVisitorNo(vNo);
                var mp = getModulePrice(p);
                var pp = getParameterPrice(cNo, vNo, response.pricePerCleintForWinAccounting, response.pricePerVisitorForWinAccounting);
                setModulePrice(mp);
                setParameterPrice(pp);
                var value = 0;
                value = Math.floor(((p.basePrice + mp + pp)*discountPercent)/100);
                setDiscountValue(value);

                var taxAmnt = Math.floor(((p.basePrice + mp + pp - value)*taxPrc)/100);
                setTaxAmount(taxAmnt);
                setLaodingProducts(false);
                setApplyScroll(2);
            }
            else{
                setLoadingProductDetatilErrorMessage(response.message);
                setLaodingProducts(false);
                setRetryShowProductDetail(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            setLoadingProductDetatilErrorMessage(error.message);
            setLaodingProducts(false);
            setRetryShowProductDetail(true);
        });
    }
    const getPackageCaption = function(pn){
        if(pn == "SimpleWinAccounting") return "نسخه حسابداری ساده";
        if(pn == "ServiceWinAccounting") return "نسخه حسابداری خدماتی";
        if(pn == "BusinesseWinAccounting") return "نسخه حسابداری فروشگاهی/بازرگانی";
        if(pn == "VisitoryWinAccounting") return "نسخه ویزیتوری (پخش سرد و گرم )";
        if(pn == "BarFrooshiWinAccounting") return "نسخه میادین میوه و تره بار (بار فروشی)";
        if(pn == "ResturantWinAccounting") return "نسخه رستوران و اغذیه فروشی";
        if(pn == "WorkersWinAccounting") return "نسخه خدمات تامین نیرو";
        if(pn == "ProductWinAccounting") return "تولیدی";

        return "";
    }
    const getModulePrice = function(p){
        var res = 0;
        for(var i=0;i<p.modules.length;i++){
            if(p.modules[i].isChecked){
                res += p.modules[i].price;
            }
        }
        return res;
    }
    const getParameterPrice = function(cNo, vNo, ppc, ppv){
        var res = parameterHelper.getWinAccountingParameterPrice(cNo, vNo, ppc, ppv);
        return res;
    }
    const onModuleCheckChanged = (code, value, ind) => {
        var res = {...product};
        res.modules[ind].isChecked = !value;
        setProduct(res);
        var mp = getModulePrice(res);
        var pp = getParameterPrice(maxClientNo, maxVisitorNo, pricePerCleintForWinAccounting, pricePerVisitorForWinAccounting);
        setModulePrice(mp);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((product.basePrice + mp + pp)*discountPercent)/100);
        setDiscountValue(value);

        var taxAmnt = Math.floor(((product.basePrice + mp + pp - value)*taxPercent)/100);
        setTaxAmount(taxAmnt);

    };    
    const onMaxClientNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxClientNo(v);
        var pp = getParameterPrice(v, maxVisitorNo, pricePerCleintForWinAccounting, pricePerVisitorForWinAccounting);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    
        var taxAmnt = Math.floor(((product.basePrice + modulePrice + pp - value)*taxPercent)/100);
        setTaxAmount(taxAmnt);
    }

    const onMaxVisitorNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxVisitorNo(v);
        var pp = getParameterPrice(maxClientNo, v, pricePerCleintForWinAccounting, pricePerVisitorForWinAccounting);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    
        var taxAmnt = Math.floor(((product.basePrice + modulePrice + pp - value)*taxPercent)/100);
        setTaxAmount(taxAmnt);
    }
    const checkDiscountToken = () =>{
        if(discountToken.length <12){
            setErorVisible(true);
            setErrorMessage("کد تخفیف باید حداقل 12 حرف یا رقم باشد");
            return;
        }
        // var check = util.IsMobileValid(discountMobile);
        // if(!check.valid){
        //     setErorVisible(true);
        //     setErrorMessage(check.msg);
        //     return;
        // }
        setCheckDiscount(true);
        var params = {login:{}, code:discountToken, mobile:discountMobile};
        var url = config.Server+`/payment/discount-token/check`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setDiscountPercent(response);
                var value = 0;
                value = Math.floor(((product.basePrice + modulePrice + parameterPrice)*response)/100);
                setDiscountValue(value);
                setCheckDiscount(false);
                     
                var taxAmnt = Math.floor(((product.basePrice + modulePrice + parameterPrice-value)*taxPercent)/100);
                setTaxAmount(taxAmnt);
   
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setCheckDiscount(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setCheckDiscount(false);
        });
    }
    const onContinueButtonClick = ()=>{
        saveBuyInLocal();
    }
    const saveBuyInLocal = ()=>{
        var modules = [];
        for(var i=0;i<product.modules.length;i++){
            if(product.modules[i].isChecked){
                modules.push(product.modules[i].code);
            }
        }
        var buy = {
            productId:product.id,
            enName:product.enName,
            buyGoal:"buyContract",
            productType:productType,
            modules:modules,
            parameters :{
                maxClientNo:maxClientNo,
                maxVisitorNo:maxVisitorNo,
                maxStudentNo:0,
                maxSchoolNo:0,
                maxMemberNo:0,
                maxBillNo:0
            },
            price:(product.basePrice + modulePrice + parameterPrice - discountValue),
            discountToken:discountToken,
            discountMobile:discountMobile,

        };
        util.saveBuy(buy);
        localStorage.setItem("HanaBeforeGetCompanyDetatilUrl", "/product/win-accounting?software=" + software);  
        setRedirectUrl("/get-company-detail");
    }
    return (
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        laodingProducts?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت مشخصات محصول..." />
                </Col>
            </Row>            
        </>
        :        
        retryShowProductDetail?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <table>
                    <tbody>
                        <tr><td style={{textAlign:"center"}}>خطا در دریافت مشخصات محصول</td></tr>
                        <tr><td style={{textAlign:"center"}}>{loadingProductDetatilErrorMessage}</td></tr>
                        <tr><td style={{textAlign:"center"}}><Button severity="Primary" onClick={()=>{loadProductDetail(software)}} style={{borderRadius:"5px"}}>تلاش مجدد</Button></td></tr>
                    </tbody>
                    </table>
                </Col>
            </Row>
            
        </>
        :        
        <>
            <Row style={{marginBottom:"10px"}}>
                <Col md={3} style={{padding:"10px", position:"relative"}}>
                    <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate("/products");}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                </Col>
            </Row>
            <Row style={{margin:"10px 0px", padding:"0px"}}>
                <Col md="4" style={{margin:"0px", padding:"5px", boxSizing:"border-box"}}>
                    <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}} ref={targetRef1}>
                        <div style={{backgroundColor:"#ccddff", padding:"12px"}}>انتخاب ماژول های مورد نیاز</div>
                        <div style={{padding:"10px 0px 2px 0px"}}>
                            <div style={{padding:"5px"}}>شما محصول [<label style={{color:"rgb(8, 106, 8)", fontWeight:"bold"}}>{product.productType.title}</label>] را انتخاب نموده اید</div>
                            <div style={{padding:"5px"}}>پکیج : <label style={{color:"rgb(21, 24, 196)", fontWeight:"bold"}}>{packageCaption}</label></div>
                            <div style={{padding:"5px"}}>ماژول های مورد نیاز را نیز انتخاب کنید</div>
                            <Table hover striped key={"moduletable"}>
                                <tbody  key={"moduletablebody"}>
                                {
                                    product.modules.map((m, mInd)=>{
                                        return(
                                            <tr key={"tr_" + String(mInd)}>
                                                <td style={{borderBottom:"0px"}} key={"td1_" + String(mInd)}>
                                                    <div key={"divCheckBox_"+String(mInd)} className="flex align-items-center">
                                                        <Checkbox disabled={m.isMandatory} value={m.isChecked} inputId={"chkModule_"+String(mInd)} onChange={(e)=>onModuleCheckChanged(m.code, e.value, mInd)} checked={m.isChecked} />
                                                        <label htmlFor={"chkModule_"+String(mInd)} className="ml-2">&nbsp;{m.title}</label>
                                                    </div>
                                                </td>
                                                <td style={{borderBottom:"0px"}} key={"td2_" + String(mInd)}>
                                                    {util.SeperatePrice(m.price)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </Table>
                            <table style={{width:"100%"}}>
                                <tbody>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>جمع ماژول ها</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(modulePrice)}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                    </div>        
                </Col>
                <Col md="4" style={{margin:"0px", padding:"5px", boxSizing:"border-box"}}>
                    <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}}>
                        <div style={{backgroundColor:"#ccddff", padding:"12px"}}>تنظیم پارامترها</div>
                        <div style={{padding:"10px 0px 10px 0px"}}>
                            <Table hover striped key={"parametertable"}>
                                <tbody  key={"parametertablebody"}>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد دستگاه برای نصب</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            <InputText value={maxClientNo} onChange={(e) => onMaxClientNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد ویزیتور(مازاد بر 3 نفر)</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            <InputText value={maxVisitorNo} onChange={(e) => onMaxVisitorNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table key={"discounttable"} style={{marginTop:"50px"}}>
                                <tbody  key={"discounttablebody"}>
                                    <tr><td colSpan={2}>در صورتی که توکن تخفیف در اختیار دارید جهت بررسی و استفاده، مشخصات آنرا در کادر زیر وارد کنید</td></tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>کد تخفیف</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            <InputText value={discountToken} onChange={(e) => {setDiscountToken(e.target.value); setDiscountValue(0);}} style={{width:"160px", textAlign:"center", direction:"ltr"}} maxLength={20} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ تخفیف</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            {util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"center", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0"}} colSpan={2}>
                                            <Button severity="Primary" loading={checkDiscount} onClick={()=>{checkDiscountToken()}} style={{borderRadius:"5px"}}>بررسی کد تخفیف</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <table style={{width:"100%"}}>
                                <tbody>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>قیمت پایه</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(product.basePrice)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>جمع ماژول ها</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(modulePrice)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>سایر پارامتر ها</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(parameterPrice)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>جمع هزینه ها</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(product.basePrice + modulePrice + parameterPrice)}</td>
                                    </tr>
                                    {
                                        discountValue<=0?<></>
                                        :
                                        <>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تخفیف</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ بعد از تخفیف</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(product.basePrice + modulePrice + parameterPrice - discountValue)}</td>
                                    </tr>
                                        </>
                                    }
                                    <tr>
                                        <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>ارزش افزوده</td>
                                        <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(taxAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"left", padding:"10px", border:"1px dashed #b0b0b0", borderRight:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>جمع کل</td>
                                        <td style={{textAlign:"right", padding:"10px", border:"1px dashed #b0b0b0", borderLeft:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>{util.SeperatePrice(product.basePrice + modulePrice + parameterPrice - discountValue + taxAmount)}</td>
                                    </tr>
                                </tbody>
                            </table> 
                            <div style={{padding:"5px", textAlign:"center"}}>
                                <Button severity="success" loading={checkDiscount} onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;تائید محصول و ادامه&nbsp;&nbsp;</Button>
                            </div>                               
                        </div>
                    </div>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            </>

    )
}
